import { Text, Flex, Grid, Button } from '@raskrask-dk/rr-components'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { PropsErrorTemplate } from './error.props'

export const ErrorTemplate = ({
    buttonHandler,
    textHandler,
}: PropsErrorTemplate): ReactElement => {
    const { t } = useTranslation()

    const [primaryTextBlock] = textHandler
    const [onClickHandler, buttonText, buttonType] = buttonHandler

    const buttonDataCy =
        buttonType === 'Rebook'
            ? 'redirectToRebookingButton'
            : buttonType === 'RestartFlow'
            ? 'restartFlowButton'
            : ''

    return (
        <Grid gap={16}>
            <Text css={{ marginTop: '20px' }}>{t(primaryTextBlock)}</Text>
            {buttonType !== 'NoButton' && (
                <Flex css={{ 'justify-content': 'center' }}>
                    <Button
                        data-cy={buttonDataCy}
                        css={{ px: '$2' }}
                        size="large"
                        variant="success"
                        onClick={() => {
                            onClickHandler()
                        }}
                    >
                        {buttonText}
                    </Button>
                </Flex>
            )}
        </Grid>
    )
}
